import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addMasterSentencesAsync,
  getAllMasterSentencesAsync,
  getMasterSentenceByIdAsync,
  updateMasterSentencesByIdAsync,
  deleteMasterSentenceAsync,
  uploadWallOfFameExcelAsync,
  getAllBulkFilesWallOfFame,
} from "./masterdailysenteces.async";

const initialState = {
  masterDailySentencesLoader: false,
  addMasterDailySentences: [],
  allMasterDailySentences: [],
  getMasterDailySentencesById: [],
  updateMasterDailySentencesById: [],
  deleteMasterDailySentences: [],
  bulkMasterDailySentences: [],
};

export const masterdailysentecesSlice = createSlice({
  name: "language",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        addMasterSentencesAsync.pending,
        getAllMasterSentencesAsync.pending,
        getMasterSentenceByIdAsync.pending,
        updateMasterSentencesByIdAsync.pending,
        deleteMasterSentenceAsync.pending,
        uploadWallOfFameExcelAsync.pending,
        getAllBulkFilesWallOfFame.pending
      ),
      (state) => {
        state.masterDailySentencesLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllBulkFilesWallOfFame.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.bulkFilesWallOfFame = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(uploadWallOfFameExcelAsync.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.bulkMasterDailySentences = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(addMasterSentencesAsync.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.addMasterDailySentences = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllMasterSentencesAsync.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.allMasterDailySentences = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getMasterSentenceByIdAsync.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.getMasterDailySentencesById = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(updateMasterSentencesByIdAsync.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.updateMasterDailySentencesById = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteMasterSentenceAsync.fulfilled),
      (state, action) => {
        state.masterDailySentencesLoader = false;
        state.deleteMasterDailySentences = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        addMasterSentencesAsync.rejected,
        getAllMasterSentencesAsync.rejected,
        getMasterSentenceByIdAsync.rejected,
        updateMasterSentencesByIdAsync.rejected,
        deleteMasterSentenceAsync.rejected,
        uploadWallOfFameExcelAsync.rejected,
        getAllBulkFilesWallOfFame.rejected
      ),
      (state, action) => {
        state.masterDailySentencesLoader = false;
      }
    );
  },

  reducers: {
    emptyMasterSentences: () => initialState,
    resetmasterMasterSentencesLoader: (state) => {
      state.masterDailySentencesLoader = false;
    },
  },
});

export const { emptyMasterSentences, resetmasterMasterSentencesLoader } =
  masterdailysentecesSlice.actions;

export default masterdailysentecesSlice.reducer;
